import React, { useCallback, useState } from 'react';

import { Divider } from '@material-ui/core';

import { TextInput, NumericInput } from '../EditorFormElements';
import { Collapsible, FormFieldWrapper } from '../Global';
import { Popover } from '.';

import makePath from '../../utils/makePath';


export const Target = ({given = {} ,index, ...props}) => {
  const [label, setLabel] = useState( given.label ? given.label : `Target ${index + 1}`)

  const callback = useCallback((name,value)  => setLabel(value), [setLabel]);

  const path = makePath(props.path,index);

  return (
    <Collapsible headerTag="h4" title={label} sortableChild>
      
      <FormFieldWrapper>

        <TextInput 
          label="Target Name for Screen Reader" 
          defaultText={`Target ${index + 1}`}
          name="label"
          path={path}
          callback={callback}
          help="Provide a target name to match alt text provided for the background image, if any."
          given={given.label}
        /> 
      </FormFieldWrapper>

      <h5 className="form-section-header">Target Position</h5>
        
      <FormFieldWrapper halfSizeInputs>
        
        <NumericInput
          label="Horizontal Alignment" 
          min={0} 
          max={100} 
          name="left" 
          path={path}
          defaultNumber={50.00}
          given={given.left}
          style={{width: 168}}
          decimalPlaces={2}
        />
      
        <NumericInput 
          label="Vertical Alignment" 
          min={0} 
          max={100} 
          name="top" 
          path={path}
          defaultNumber={50.00}
          given={given.top}
          style={{width: 168}}
          decimalPlaces={2}
        />

      </FormFieldWrapper>

      <Divider/>

      <h5 className="form-section-header">Target's Popover</h5>

      <Popover given={given.popover} path={path} showColorPicker={props.showColorPicker} />
          
      {props.deleteBtn}

    </Collapsible>
  )
}